export const IS_MOBILE_WEBVIEW =
  typeof window.flutter_inappwebview !== 'undefined';
